<mf-page title="Editar operación">
  @if (isLoaded) {
  <mf-operation
    [isEditing]="true"
    (executeOperation)="executeOperation($event)"
    (backToDraft)="backToDraft($event)" />
  }
</mf-page>
